import {FC} from 'react';
import {Controller} from 'react-hook-form';
import {
	DirectionalHint,
	ISpinButtonProps,
	Position,
	SpinButtonCompat as SpinButton,
} from 'components/FluentUICompat';
import * as React from 'react';
import {HookFormProps} from './HookFormProps';
import {
	TooltipWithComponentWithAriaDescribedBy,
	TooltipOptionsForComponentOrColumn,
} from 'features/localizedTooltips';

type Props = HookFormProps &
	ISpinButtonProps &
	TooltipOptionsForComponentOrColumn;

export const ControlledSpinButton: FC<Props> = ({
	tooltipHostProps,
	...other
}) => {
	return (
		<Controller
			name={other.name}
			control={other.control}
			rules={other.rules}
			defaultValue={other.defaultValue}
			render={({field: {onChange, onBlur, value}}) => (
				<TooltipWithComponentWithAriaDescribedBy
					{...other}
					Component={props => (
						<SpinButton
							{...props}
							min={other.min}
							max={other.max}
							step={other.step}
							labelPosition={other.labelPosition ?? Position.top}
							decrementButtonAriaLabel={'decrement'}
							incrementButtonAriaLabel={'increment'}
							onChange={(_, val: any) => {
								if (val) {
									onChange(parseInt(val, 10));
								}
							}}
							value={value ? `${value}` : undefined}
							onBlur={onBlur}
						/>
					)}
					tooltipHostProps={{
						translationKey: other.name,
						directionalHint: DirectionalHint.leftCenter,
						...tooltipHostProps,
					}}
				/>
			)}
		/>
	);
};
